const awsconfig = {
    aws_project_region: 'eu-west-1',
    aws_cognito_region: 'eu-west-1',
    aws_user_pools_id: `${process.env.REACT_APP_CUSTOMER_USER_POOL_ID}`,
    aws_user_pools_web_client_id: `${
        process.env.REACT_APP_CUSTOMER_WEB_CLIENT_ID
    }`
};

export default awsconfig;
